import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ContenuTemoignage } from '@components/contenu-temoignage/models';
import { ImageComponent } from '@shared/components/image';
import { SvgComponent } from '@shared/components/svg';
import { HandleHtmlLinksDirective } from '@shared/directives';
import { splitBrandAndStore } from '@shared/utils';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-contenu-temoignage',
  imports: [SvgComponent, HandleHtmlLinksDirective, ImageComponent, NgTemplateOutlet, RouterLink],
  templateUrl: './contenu-temoignage.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContenuTemoignageComponent extends AbstractDynamicComponent<ContenuTemoignage> {
  protected readonly brandAndStore = computed(() => splitBrandAndStore(this.data.storeBanner.storeName));
}
